
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Zona } from "app/models/zona";
export abstract class AbPerfilAcesso extends AppService {
  abstract prefixo: string;

  abstract desativar(id: number);
  abstract getAllPerfilAcessos(filter: AppFilter);
  abstract saveUpdatePerfilAcesso(obj: Zona);
  abstract getPerfilAcesso(id: number);
  abstract getAllPerfilAcessosAtivos();
  abstract getLimitePerfisCadastrados();
}